export const constants = {
    VIMEO_PLAYER_URL: 'https://player.vimeo.com/video',
    YOUTUBE_PLAYER_URL: 'https://www.youtube.com/embed',

    searchOnlyEnums: ['BEEF_CUTS', 'COLLECTIONS', 'CUISINE', 'COOKING_METHODS', 'RECIPES', 'AUTHORS', 'ARTICLES', 'QR_CODES'],
};

export default constants;